/**
 * 把 Blob 存成本地文件。CSV 导出走的是 axios 的 blob 响应，
 * Content-Disposition 里的文件名拿不到（响应头不进业务层），文件名由调用方拼。
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  // 立刻 revoke 可能打断下载，留给事件循环在下载启动后再回收
  setTimeout(() => URL.revokeObjectURL(url), 0)
}

/** 报表文件名：stock-summary-20261004.csv */
export function csvName(prefix: string): string {
  const d = new Date()
  const pad = (n: number): string => String(n).padStart(2, '0')
  return `${prefix}-${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}.csv`
}
